
import { HTTP } from '@/router/http'

// initial state
const getDefaultState = () => {
	return {
		vocs: [],
		current: {
			name: '',
			language: '',
			terms: []
		}
	}
}

const state = getDefaultState()

// getters
const getters = {
	vocs: state => state.vocs
}

// actions
const actions = {
	getList ({commit},) {
		HTTP.get('list').then(res => {
			commit("LIST_VOCS",res.data)
		})
	},
	setVoc ({commit, state},voc) {
		let voc_idx = _.findIndex(state.vocs, v => v.name == voc.name);
		if (voc_idx > -1){
			return HTTP.put("/voc",voc).then( () => {
				commit("UPDATE_VOC",{idx: voc_idx, voc: voc});		
			});
		} 
		else {
			commit('NEW_VOC',voc)			
		}
	},
	getVoc({commit, state}, voc){
		let idx = _.findIndex(state.vocs, lv => {
			return lv.name == voc.name && lv.language == voc.language
		})
		if (idx == -1 || state.vocs[idx].terms.length === 0){
			return HTTP.get('voc/'+voc.language+'/'+voc.name).then(res => {
				if (res.data){
					voc.terms = res.data;
					commit('GET_VOC',voc);
					return voc;
				}
			})						
		}
	},
	setRepeat({ commit, state }, voc){
		let idx = 0;
		_.forEach(state.vocs, v => {
			if (v.language === voc.language && v.name.replace(/_repet\d+/,"") === voc.name.replace(/_repet\d+/,"")){
				if (v.name.match(/_repet(\d+)/)){
					let vidx = +v.name.match(/_repet(\d+)/)[1];
					if (vidx > idx) idx = vidx;
				}
			}
		})
		idx++;
		voc.name = voc.name.replace(/_repet\d+/,"")+"_repet"+idx;
		commit("NEW_VOC", voc );
	}
}

// mutations
const mutations = {
	LIST_VOCS (state,lists){
		_.forEach(lists,(vocs,language) => {
			_.forEach(vocs, v => {
				let idx = _.findIndex(state.vocs, lv => {
					return lv.name == v && lv.language == language
				})
				if (idx == -1) state.vocs.push({
					name: v,
					language: language,
					terms: []
				})				
			})
		})
	},
	GET_VOC (state, voc){
		let idx = _.findIndex(state.vocs, lv => {
			return lv.name == voc.name && lv.language == voc.language
		})
		if (idx > -1) state.vocs[idx].terms = voc.terms;
	},
	NEW_VOC (state,voc){
		HTTP.post("voc",voc).then(res => {
			state.vocs.push(voc)
		})
	},
	UPDATE_VOC (state, params){
		state.vocs[params.idx].name = params.voc.name
		state.vocs[params.idx].language = params.voc.language
		state.vocs[params.idx].terms = params.voc.terms
	},
	RESET_STATE (state) {
		Object.assign(state, getDefaultState())
	},
	ADD_VOC (state,voc) {
		state.vocs.push(voc)
	},
	DELETE_VOC (state,voc){
		HTTP.delete("voc/"+voc.language+"/"+voc.name).then( () => {
			_.remove(state.vocs, v => {
				return (v.name === voc.name && v.language === voc.language)
			})
		})
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
